import useSWR from 'swr';

import { clientApiGet } from 'lib/api_helper';
import { Model, SimilarBrandModels } from 'types';

import { SimilarAppearanceModels } from './SimilarAppearanceModels';
import { SimilarModels } from './SimilarModels';

export const SimilarTestIds = {
  similarModels: 'similar-models',
  similarAppearance: 'similar-appearance'
};

export type SimilarProps = {
  model: Model;
  formatTitle?: (title: string) => React.ReactNode;
};

export const Similar: React.FC<SimilarProps> = ({ model, formatTitle }) => {
  const seriesId = model.series === undefined ? -1 : model.series.id;
  const { data: similarResults } = useSWR<SimilarBrandModels>(
    model
      ? `/api/search/similar?brand=${model.brand.id}&series=${seriesId}&dialColor=${model.dialColor.id}&caseMaterial=${model.caseMaterials[0].id}`
      : null,
    clientApiGet
  );

  return (
    <div>
      <div data-testid={SimilarTestIds.similarModels}>
        <SimilarModels model={model} similarResults={similarResults} formatTitle={formatTitle} />
      </div>
      <div data-testid={SimilarTestIds.similarAppearance}>
        <SimilarAppearanceModels model={model} similarResults={similarResults} formatTitle={formatTitle} />
      </div>
    </div>
  );
};
